module.exports = __webpack_public_path__ + "img/cyber_chick.12a1cdcc.png";